<template>
  <div>
    <el-dialog v-if="show" title="" :visible.sync="show" width="55%" :before-close="handleClose"
      v-loading="dialogLoading" :close-on-click-modal="false">
      <avue-crud ref="crud" :data="tableData" :option="option" :table-loading="showLoading" :page.sync="page"
        @on-load="onLoad" @selection-change="selectionChange" :reserveSelection="selectedRowKeys">
        <template #header>
          <div>
            <div class="flex flex-wrap align-items marginBottom20">
              <div class="flex align-items marginRight10 marginBottom10 ">
                <span class="span marginRight10 width80 textAlignRight">网关ID :
                </span>
                <div class="width200">
                  <el-input v-model="searchData.gatewayId" placeholder="请输入" clearable maxlength="50"></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width80 textAlignRight">网关名称 :
                </span>
                <div class="width200">
                  <el-input v-model="searchData.name" placeholder="请输入" clearable maxlength="50"></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width80 textAlignRight">分组/ID :
                </span>
                <div class="width200">
                  <el-input v-model="searchData.groupId" placeholder="请输入分组名称/ID" clearable maxlength="50"></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width80 textAlignRight">创建人 :
                </span>
                <div class="width200">
                  <el-input v-model="searchData.nickname" placeholder="请输入创建人名称" clearable maxlength="50"></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width80 textAlignRight">创建人ID :
                </span>
                <div class="width200">
                  <el-input v-model="searchData.userId" placeholder="请输入创建人ID" clearable maxlength="50"></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width80 textAlignRight">手机号码 :
                </span>
                <div class="width200">
                  <el-input v-model="searchData.phone" placeholder="请输入" clearable maxlength="11"></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width80 textAlignRight">创建时间 :
                </span>
                <div class="width200">
                  <el-date-picker v-model="searchData.createTime" type="daterange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" :clearable="true">
                    <!-- @change="handleSearch" -->
                  </el-date-picker>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width80 textAlignRight">网关地址 :
                </span>
                <div class="width200">
                  <el-input v-model="searchData.macAddr" placeholder="请输入" clearable maxlength="50"></el-input>
                </div>
              </div>
              <el-button size="medium" type="primary" @click="handleSearch" class="marginLeft10"
                style="margin-bottom: 10px">搜索</el-button>
              <el-button size="medium" type="info" @click="handleReset" class="marginLeft10 marginRight10"
                style="margin-bottom: 10px">重置</el-button>
              <div class="flex align-items marginRight10 marginBottom10">
                <el-button type="danger" size="medium" @click="handleDeletes([...selectedRowKeys])">删除</el-button>
              </div>
            </div>
          </div>
        </template>
        <template slot="image" slot-scope="{ row }">
          <el-image style="width: 80px; height: 80px" :src="row.image" :preview-src-list="[row.image]">
          </el-image>
        </template>
      </avue-crud>
      <div style="text-align: center; margin-top: 30px">
        <el-button class="marginLeft10" type="" @click="handleCancel">取消</el-button>
        <el-button class="marginLeft10" type="primary" @click="handSelected">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { upgradeGatewayList } from "@/api/upgrade/firmware";
import dayjs from "dayjs";
import {
  EUpgradeMethod,
  MUpgradeMethod,
  OUpgradeMethod,
  EUpgradeScope,
  MUpgradeScope,
  OUpgradeScope,
} from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "index",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectKey: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      EUpgradeMethod: EUpgradeMethod,
      MUpgradeMethod: MUpgradeMethod,
      OUpgradeMethod: OUpgradeMethod,
      EUpgradeScope: EUpgradeScope,
      MUpgradeScope: MUpgradeScope,
      OUpgradeScope: OUpgradeScope,
      searchData: {},
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      option: {
        rowKey: "id",
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "ID",
            prop: "gatewayId",
          },
          {
            label: "网关名称",
            prop: "name",
          },
          {
            label: "网关图片",
            prop: "image",
          },
          {
            label: "网关型号",
            prop: "foreignCommType",
          },
          {
            label: "网关地址",
            prop: "macAddr",
          },
          {
            label: "归属分组",
            prop: "groupName",
          },
          {
            label: "创建人",
            prop: "nickname",
          },
          {
            label: "创建人手机",
            prop: "phone",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },
      selectedRowKeys: this.selectKey, //表格勾选中的数据
      dialogChange: false,
      dialogLoading: false,
    };
  },
  watch: {
    show(nVal) {
      //当已经选择过用户又重新打开选择页面时
      if (nVal && this.selectedRowKeys.length) {
        this.$nextTick(() => {
          //同步用户的选择
          this.dialogChange = true
        });
      } else {
        this.dialogChange = false
      }
    },
  },
  created() { },
  methods: {
    toggleSelection(val) {
      this.$refs.crud.toggleSelection(val);
    },
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.bindTimeStart = dayjs(this.searchData.createTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        searchData.bindTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      upgradeGatewayList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
          //同步用户的选择
          if (this.selectedRowKeys && this.dialogChange) {
            this.toggleSelection(this.selectedRowKeys);
            this.dialogChange = false;
          }
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {};
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //关闭
    handleClose() {
      this.$emit("closeTable");
    },
    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
    },
    //点击取消
    handleCancel() {
      //清除后来的选择
      this.selectedRowKeys = this.selectKey
      this.$emit("closeTable");
    },
    //点击确定
    handSelected() {
      this.$emit("handSelected", this.selectedRowKeys);
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}
</style>
